import { render, staticRenderFns } from "./FormAddMedicines.vue?vue&type=template&id=3ece83fe&"
import script from "./FormAddMedicines.vue?vue&type=script&lang=js&"
export * from "./FormAddMedicines.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports